// A2 - Ünite 5: Modal Verbs (must, should, have to)
// Hedef: Zorunluluk, tavsiye, gereklilik

export const A2_UNIT_5 = {
  'A2-U5-L1': {
    id: 'A2-U5-L1',
    title: 'Must (Zorunluluk)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Must - Zorunluluk',
          explanation: '"Must" güçlü bir zorunluluk ifade eder. Genellikle kurallar ve yasalar için kullanılır.',
          table: {
            headers: ['Özne', 'Must', 'Fiil', 'Örnek'],
            rows: [
              ['I/You', 'must', 'wear', 'You must wear your uniform.'],
              ['He/She', 'must', 'follow', 'She must follow the rules.'],
              ['We/They', 'must', 'check', 'We must check the cabin.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Uçuş Kuralları',
          table: {
            headers: ['Kural', 'Türkçesi'],
            rows: [
              ['Passengers must fasten their seatbelts.', 'Yolcular emniyet kemerlerini bağlamalı.'],
              ['You must turn off your phone.', 'Telefonunuzu kapatmalısınız.'],
              ['Cabin crew must check emergency equipment.', 'Kabin ekibi acil durum ekipmanlarını kontrol etmeli.'],
              ['We must follow safety procedures.', 'Güvenlik prosedürlerine uymalıyız.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Must her özneyle aynı kalır - "musts" OLMAZ!'
        },
        {
          type: 'vocabulary',
          title: '✈️ Zorunluluk Kelimeleri',
          words: [
            { en: 'mandatory', tr: 'zorunlu', pronunciation: '/ˈmændətəri/' },
            { en: 'required', tr: 'gerekli', pronunciation: '/rɪˈkwaɪəd/' },
            { en: 'compulsory', tr: 'mecburi', pronunciation: '/kəmˈpʌlsəri/' },
            { en: 'regulation', tr: 'yönetmelik', pronunciation: '/ˌreɡjʊˈleɪʃn/' },
            { en: 'policy', tr: 'politika', pronunciation: '/ˈpɒləsi/' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Passengers _____ fasten their seatbelts.',
          options: ['must', 'musts', 'must to', 'musting'],
          correct: 'must',
          explanation: 'Must + fiil kök hali'
        },
        {
          type: 'fillInBlank',
          sentence: 'You _____ (must / turn off) your phone during takeoff.',
          answer: 'must turn off',
          hint: 'must + fiil'
        },
        {
          type: 'matching',
          instruction: 'Kuralları tamamlayın',
          pairs: [
            { left: 'You must', right: 'follow safety rules' },
            { left: 'Crew must', right: 'check equipment' },
            { left: 'Passengers must', right: 'stay seated' }
          ]
        }
      ]
    }
  },
  'A2-U5-L2': {
    id: 'A2-U5-L2',
    title: "Mustn't (Yasak)",
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Mustn\'t - Yasak',
          explanation: '"Mustn\'t" bir şeyin yasak olduğunu ifade eder. "YAPMAMALISINIZ" anlamındadır.',
          table: {
            headers: ['Olumlu (Zorunluluk)', 'Olumsuz (Yasak)'],
            rows: [
              ['You must sit down.', "You mustn't stand."],
              ['You must fasten seatbelt.', "You mustn't unfasten."],
              ['You must follow rules.', "You mustn't break rules."]
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Uçuş Yasakları',
          table: {
            headers: ['Yasak', 'Türkçesi'],
            rows: [
              ["You mustn't smoke on the aircraft.", 'Uçakta sigara içmemeli/içemezsiniz.'],
              ["You mustn't use your phone during takeoff.", 'Kalkışta telefon kullanmamalısınız.'],
              ["You mustn't block the emergency exit.", 'Acil çıkışı kapatmamalısınız.'],
              ["You mustn't interfere with crew.", 'Ekibe müdahale etmemelisiniz.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 mustn\'t = YASAK (yapmayın!) | don\'t have to = GEREKMİYOR (istersenız yapın)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: "You _____ smoke on the aircraft.",
          options: ["mustn't", "must", "don't have to", "have to"],
          correct: "mustn't",
          explanation: "Yasak = mustn't"
        },
        {
          type: 'fillInBlank',
          sentence: "Passengers _____ (mustn't / block) the emergency exits.",
          answer: "mustn't block",
          hint: "Yasak - mustn't + fiil"
        },
        {
          type: 'matching',
          instruction: 'Yasakları tamamlayın',
          pairs: [
            { left: "You mustn't", right: 'smoke' },
            { left: "You mustn't", right: 'stand during takeoff' },
            { left: "You mustn't", right: 'use phone' }
          ]
        }
      ]
    }
  },
  'A2-U5-L3': {
    id: 'A2-U5-L3',
    title: 'Have to / Has to (Zorunluluk)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Have to / Has to',
          explanation: '"Have to" dış kaynaklardan gelen zorunluluklar için kullanılır (kurallar, yasalar, iş gereksinimleri).',
          table: {
            headers: ['Özne', 'Have/Has to', 'Örnek'],
            rows: [
              ['I/You/We/They', 'have to', 'I have to work tomorrow.'],
              ['He/She/It', 'has to', 'She has to wear a uniform.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Must vs Have to',
          table: {
            headers: ['Must', 'Have to', 'Fark'],
            rows: [
              ['I must be on time.', 'I have to be on time.', 'Kişisel vs dış kural'],
              ['You must study.', 'You have to pass the exam.', 'Kişisel öneri vs zorunlu'],
              ['Sadece şimdiki zaman', 'Tüm zamanlarda kullanılır', 'Esneklik']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Geçmiş: had to | Gelecek: will have to - "must" bu zamanlarda kullanılmaz!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'She _____ wear a uniform at work.',
          options: ['has to', 'have to', 'must to', 'having to'],
          correct: 'has to',
          explanation: 'She ile has to kullanılır'
        },
        {
          type: 'multipleChoice',
          question: 'I _____ work early tomorrow. (geçmiş)',
          options: ['had to', 'must', 'have to', 'has to'],
          correct: 'had to',
          explanation: 'Geçmiş zamanda: had to'
        },
        {
          type: 'fillInBlank',
          sentence: 'Cabin crew _____ (have to / pass) medical checks.',
          answer: 'have to pass',
          hint: 'Crew (çoğul) ile have to'
        }
      ]
    }
  },
  'A2-U5-L4': {
    id: 'A2-U5-L4',
    title: 'Should (Tavsiye)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Should - Tavsiye',
          explanation: '"Should" tavsiye vermek için kullanılır. "Must" kadar güçlü değildir.',
          table: {
            headers: ['Should', 'Shouldn\'t', 'Anlam'],
            rows: [
              ['You should rest.', "You shouldn't worry.", 'Tavsiye'],
              ['You should apply.', "You shouldn't give up.", 'Öneri'],
              ['You should practice.', "You shouldn't be late.", 'Yönlendirme']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Mülakat Tavsiyeleri',
          table: {
            headers: ['Tavsiye', 'Türkçesi'],
            rows: [
              ['You should research the company.', 'Şirketi araştırmalısınız.'],
              ['You should dress professionally.', 'Profesyonel giyinmelisiniz.'],
              ['You should arrive early.', 'Erken varmalısınız.'],
              ['You should practice your answers.', 'Cevaplarınızı pratik etmelisiniz.'],
              ["You shouldn't be nervous.", 'Gergin olmamalısınız.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 should = tavsiye (yapsan iyi olur) | must = zorunluluk (yapmak zorundasın)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'You _____ research the company before the interview.',
          options: ['should', 'must', 'have to', 'will'],
          correct: 'should',
          explanation: 'Tavsiye = should'
        },
        {
          type: 'multipleChoice',
          question: "You _____ be late for the interview.",
          options: ["shouldn't", "mustn't", "don't have to", "won't"],
          correct: "shouldn't",
          explanation: "Tavsiye (olumsuz) = shouldn't"
        },
        {
          type: 'fillInBlank',
          sentence: 'You _____ (should / practice) your English every day.',
          answer: 'should practice',
          hint: 'Tavsiye - should + fiil'
        }
      ]
    }
  },
  'A2-U5-L5': {
    id: 'A2-U5-L5',
    title: 'Uygulama: Güvenlik Kuralları',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '✈️ Güvenlik Kuralları ve Tavsiyeler',
          explanation: 'Havacılıkta farklı zorunluluk seviyeleri:',
          table: {
            headers: ['Seviye', 'Modal', 'Örnek'],
            rows: [
              ['YASAK', "mustn't", "You mustn't smoke."],
              ['ZORUNLU (kural)', 'must/have to', 'You must fasten your seatbelt.'],
              ['TAVSİYE', 'should', 'You should drink water during the flight.'],
              ['GEREKMİYOR', "don't have to", "You don't have to finish your meal."]
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Yolculara kural anlatırken: "must" | Tavsiye verirken: "should" kullanın!'
        },
        {
          type: 'vocabulary',
          title: '✈️ Güvenlik Terimleri',
          words: [
            { en: 'prohibited', tr: 'yasak', pronunciation: '/prəˈhɪbɪtɪd/' },
            { en: 'permitted', tr: 'izinli', pronunciation: '/pəˈmɪtɪd/' },
            { en: 'recommended', tr: 'tavsiye edilen', pronunciation: '/ˌrekəˈmendɪd/' },
            { en: 'optional', tr: 'isteğe bağlı', pronunciation: '/ˈɒpʃənl/' },
            { en: 'essential', tr: 'zorunlu', pronunciation: '/ɪˈsenʃl/' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Passengers _____ fasten seatbelts during takeoff. (zorunlu)',
          options: ['must', 'should', 'can', 'might'],
          correct: 'must',
          explanation: 'Zorunluluk = must'
        },
        {
          type: 'multipleChoice',
          question: "Passengers _____ smoke on the aircraft. (yasak)",
          options: ["mustn't", "shouldn't", "don't have to", "can't"],
          correct: "mustn't",
          explanation: "Yasak = mustn't"
        },
        {
          type: 'fillInBlank',
          sentence: 'You _____ drink water during long flights. (tavsiye)',
          answer: 'should',
          hint: 'Tavsiye = should'
        },
        {
          type: 'speaking',
          instruction: 'Yolculara kuralları anlatın:',
          phrases: [
            'You must fasten your seatbelt.',
            "You mustn't smoke.",
            'You should stay hydrated.',
            "You don't have to finish your meal."
          ]
        }
      ]
    }
  },
  'A2-U5-EXAM': {
    id: 'A2-U5-EXAM',
    title: 'Ünite 5 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: 'Passengers _____ fasten their seatbelts.',
        options: ['must', 'musts', 'must to', 'musting'],
        correct: 'must',
        explanation: 'Zorunluluk: must + fiil'
      },
      {
        type: 'multipleChoice',
        question: "You _____ smoke on the aircraft.",
        options: ["mustn't", "must", "don't have to", "should"],
        correct: "mustn't",
        explanation: "Yasak = mustn't"
      },
      {
        type: 'multipleChoice',
        question: 'She _____ wear a uniform. (kural)',
        options: ['has to', 'have to', 'must to', 'having to'],
        correct: 'has to',
        explanation: 'She ile has to'
      },
      {
        type: 'multipleChoice',
        question: 'You _____ research the company. (tavsiye)',
        options: ['should', 'must', 'have to', 'will'],
        correct: 'should',
        explanation: 'Tavsiye = should'
      },
      {
        type: 'fillInBlank',
        sentence: 'Yesterday, I _____ (have to) work late.',
        answer: 'had to',
        hint: 'Geçmiş zaman: had to'
      },
      {
        type: 'matchPairs',
        instruction: 'Modal fiilleri anlamlarla eşleştirin',
        pairs: [
          { left: 'must', right: 'zorunluluk' },
          { left: "mustn't", right: 'yasak' },
          { left: 'should', right: 'tavsiye' },
          { left: "don't have to", right: 'gerekmiyor' }
        ]
      }
    ]
  }
};

export default A2_UNIT_5;
